var scope_0 = require('/home/runner/work/prof/prof/deps/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/110c0953bfb0ceb639b797cefdfd9155.js').default;
var scope_1 = require('/home/runner/work/prof/prof/deps/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91f959e521eb44cb549c67832d585ece.js').default;
var scope_2 = require('/home/runner/work/prof/prof/deps/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    